<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">Trim Mode</div>
        <a-radio-group v-model="clone.trim.mode">
            <a-radio value="both">Both Sides</a-radio>
            <a-radio value="start">Start Only</a-radio>
            <a-radio value="end">End Only</a-radio>
        </a-radio-group>
        <small class="description">
            Select which parts of the text should have whitespace removed
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";

const log = log2("StringFormatterTrim");
export default {
    name: "StringFormatterTrim",
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.trim",
            value: "",
            trim: {
                mode: "both",
            },
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 